import { getRuntimeEnv } from "./runtimeEnv";

// Mesma semântica adotada pelo painel de eventos em SoftphoneWorkspace: REACT_APP_NODE_ENV
// é pré-requisito de deploy, e a ausência dela é tratada como ambiente de desenvolvimento
// (deliberadamente — um deploy incompleto deve ficar visível, não ser mascarado como
// produção). Na imagem Docker o server.js sempre popula a variável a partir de NODE_ENV.
const nodeEnv = getRuntimeEnv("REACT_APP_NODE_ENV");

export const isDebugBuild = !nodeEnv || nodeEnv === "dev";

export function debugLog(...args: unknown[]) {
  if (isDebugBuild) console.log(...args);
}

export function debugWarn(...args: unknown[]) {
  if (isDebugBuild) console.warn(...args);
}
